import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery,
  type UseQueryResult
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { failureFlagsQueryKeys } from 'queries/failure-flags/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { AxiosError } from 'axios'
import type { FailureFlagExperiment } from 'types/api/failure-flags/failure-flags'

function fetchFailureFlagsExperiments({
  queryKey: [endpoint, teamId]
}: QueryFunctionContext<
  ReturnType<typeof failureFlagsQueryKeys.getExperiments>
>) {
  const endpointWithParams = getEndpointWithParams(endpoint, { teamId })

  return fetchQueryData<FailureFlagExperiment[]>(endpointWithParams, {})
}

export function useGetFailureFlagsExperiments(
  options?: QueryObserverOptions<FailureFlagExperiment[], AxiosError>
): UseQueryResult<FailureFlagExperiment[]> {
  const { currentTeamId } = useAuth()

  return useQuery<FailureFlagExperiment[], AxiosError>({
    ...options,
    queryKey: failureFlagsQueryKeys.getExperiments(currentTeamId),
    queryFn: fetchFailureFlagsExperiments
  })
}
